import React from 'react';

/**
 * WorshipMark — canonical worship.ro symbol.
 * Solid lavender ring enclosing two raised-arm figures forming a "W".
 * Recolors via the --logo-ink CSS variable (or currentColor when set).
 */
export const WorshipMark = ({ className = '', style = {}, width = 48, height = 48, title = 'worship.ro', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 155 152.5"
    fill="var(--logo-ink, #DDD6F5)"
    fillRule="evenodd"
    role="img"
    aria-label={title}
    width={width}
    height={height}
    className={className}
    style={{ maxWidth: '100%', maxHeight: '100%', ...style }}
    {...props}
  >
    <circle cx="56.12" cy="65.25" r="9.9" />
    <path d="M82.1,87.69c-1.88,1.63-3.38,2.51-5.23,4.42c-7.71,7.98-9.92,16.84-15.03,26.18c-3.6,6.57-10.9,7.54-15.77,1.73c-9.58-20.7-18.87-41.65-27.76-62.65c-0.62-8.3,9.53-11.52,13.46-3.71c4.59,9.1,8.4,25.63,19.56,28.76c8.57,2.4,15.15-4.28,22.56-7.04C82.25,72.26,89.35,81.41,82.1,87.69z" />
    <path d="M85.61,65c0-5.42,4.4-9.82,9.82-9.82c5.42,0,9.82,4.4,9.82,9.82s-4.4,9.82-9.82,9.82C90.01,74.82,85.61,70.43,85.61,65z" />
    <path d="M132.71,59.58c-2.26,6.02-5.53,12.56-8.18,18.51c-6.24,14.02-12.55,28.12-19.33,41.85c-1.69,1.93-3.69,3.23-6.32,3.42c-6.94,0.49-9.26-5.19-11.77-10.46c-2.61-5.49-4.58-9.29-1.82-15.4c3.08-6.81,9.61-8.19,15.02-12.25c11.2-8.41,14.69-22.32,21.15-33.99c1.23-1.03,2.72-1.91,4.35-2.08C131.72,48.55,134.65,54.39,132.71,59.58z" />
    <path d="M130.46,23.46C89.82-19.07,20.25-0.85,3.39,54.57c-18.3,60.16,40.61,118.24,100.1,94.45C154.02,128.82,168.15,62.91,130.46,23.46z M30.26,128.73C-7.35,94.42,3.93,30.7,51.57,12.34c54.2-20.89,106.71,31.49,89.48,85.98C126.01,145.91,67.71,162.88,30.26,128.73z" />
  </svg>
);

export default WorshipMark;
